// src/components/hooks/useShortenPcbSn.js

export function useShortenPcbSn() {
    const shortenPcbSn = (pcbSn) => {
        if (!pcbSn || typeof pcbSn !== 'string' || !pcbSn.includes('.')) {
            return pcbSn || '';
        }

        const [before, after] = pcbSn.split('.', 2);

        // Current short logic: first part + first 3 chars of second part
        const afterShort = after.length > 3 ? after.substring(0, 3) : after;
        const shortVersion = `${before}.${afterShort}`;

        // New: add ellipsis + last 4 characters of the full pcbSn
        const lastFour = pcbSn.length > 4 ? pcbSn.slice(-4) : pcbSn;

        // Use proper ellipsis character (…) instead of three dots
        return `${shortVersion}…${lastFour}`;
    };

    return { shortenPcbSn };
}